import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../base/Logo';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isAreasOpen, setIsAreasOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <Logo />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/" className="text-gray-700 hover:text-yellow-500 font-medium transition-colors cursor-pointer">
              Home
            </a>
            
            {/* Services Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="text-gray-700 hover:text-yellow-500 font-medium transition-colors flex items-center space-x-1 cursor-pointer"
              >
                <span>Services</span>
                <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border py-2 z-50">
                  <a href="/interior-painting" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Interior Painting
                  </a>
                  <a href="/exterior-painting" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Exterior Painting
                  </a>
                  <a href="/roof-painting" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Roof Painting
                  </a>
                  <a href="/commercial-painting" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Commercial Painting
                  </a>
                  <a href="/residential-painting" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Residential Painting
                  </a>
                </div>
              )}
            </div>

            {/* Areas Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsAreasOpen(!isAreasOpen)}
                className="text-gray-700 hover:text-yellow-500 font-medium transition-colors flex items-center space-x-1 cursor-pointer"
              >
                <span>Areas</span>
                <i className={`ri-arrow-down-s-line transition-transform ${isAreasOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isAreasOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border py-2 z-50">
                  <a href="/bellville-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Bellville Painters
                  </a>
                  <a href="/parow-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Parow Painters
                  </a>
                  <a href="/goodwood-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Goodwood Painters
                  </a>
                  <a href="/elsies-river-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Elsies River Painters
                  </a>
                  <a href="/kuils-river-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Kuils River Painters
                  </a>
                  <a href="/brackenfell-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Brackenfell Painters
                  </a>
                  <a href="/kraaifontein-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Kraaifontein Painters
                  </a>
                  <a href="/milnerton-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Milnerton Painters
                  </a>
                  <a href="/table-view-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Table View Painters
                  </a>
                  <a href="/bloubergstrand-painters" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-600 transition-colors cursor-pointer">
                    Bloubergstrand Painters
                  </a>
                </div>
              )}
            </div>

            <a 
              href="/contact" 
              className="text-black px-6 py-2 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#e9f638' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d4e532'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e9f638'}
            >
              Get a Quote
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="/" className="text-gray-700 hover:text-yellow-500 font-medium transition-colors cursor-pointer">
                Home
              </a>
              
              {/* Mobile Services */}
              <div>
                <button
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                  className="text-gray-700 hover:text-yellow-500 font-medium transition-colors flex items-center justify-between w-full cursor-pointer"
                >
                  <span>Services</span>
                  <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isServicesOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    <a href="/interior-painting" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Interior Painting
                    </a>
                    <a href="/exterior-painting" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Exterior Painting
                    </a>
                    <a href="/roof-painting" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Roof Painting
                    </a>
                    <a href="/commercial-painting" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Commercial Painting
                    </a>
                    <a href="/residential-painting" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Residential Painting
                    </a>
                  </div>
                )}
              </div>

              {/* Mobile Areas */}
              <div>
                <button
                  onClick={() => setIsAreasOpen(!isAreasOpen)}
                  className="text-gray-700 hover:text-yellow-500 font-medium transition-colors flex items-center justify-between w-full cursor-pointer"
                >
                  <span>Areas</span>
                  <i className={`ri-arrow-down-s-line transition-transform ${isAreasOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isAreasOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    <a href="/bellville-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Bellville Painters
                    </a>
                    <a href="/parow-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Parow Painters
                    </a>
                    <a href="/goodwood-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Goodwood Painters
                    </a>
                    <a href="/elsies-river-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Elsies River Painters
                    </a>
                    <a href="/kuils-river-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Kuils River Painters
                    </a>
                    <a href="/brackenfell-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Brackenfell Painters
                    </a>
                    <a href="/kraaifontein-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Kraaifontein Painters
                    </a>
                    <a href="/milnerton-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Milnerton Painters
                    </a>
                    <a href="/table-view-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Table View Painters
                    </a>
                    <a href="/bloubergstrand-painters" className="block text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer">
                      Bloubergstrand Painters
                    </a>
                  </div>
                )}
              </div>

              <a 
                href="/contact" 
                className="text-black px-6 py-2 rounded-full font-semibold transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#e9f638' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d4e532'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e9f638'}
              >
                Get a Quote
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
